import ConsumerIntegrationItem from './ConsumerIntegrationItem';

export default ConsumerIntegrationItem;
